import PriceComparison from '../../../../../pages/vip/features/price-comparison-rex/index';

export default PriceComparison;
